import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { customersApiKeyStore } from '../../../../api/customers-api-key-store';
import { officeApiKeyStore } from '../../../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../../../api/projects-api-key-store';
import { unitsApiKeyStore } from '../../../../api/units-api-key-store';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { SelectChainItem, SelectConfig, SelectResult } from '../../../../components/select/select-chain.component';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Project } from '../../../../models/project';
import { EditProjectBuildingTab } from './edit-project-building-tab';
import { SiTrackPage } from '../../../../components/si-track-page';
import { Grid } from '@mui/material';

const EditProjectBuilding = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { filters } = location.state || {};
  const getFiltesFromUrl = (params: URLSearchParams) => {
    return {
      customerID: filters?.customerID || null,
      officeID: filters?.officeID || null,
      projectID: filters?.projectID || null,
    };
  };
  const [selectedFilters, setSelectedFilters] = useState<SelectResult>(getFiltesFromUrl(searchParams));
  const [enableError, setEnableError] = useState<any>({
    customerError: false,
    officeError: false,
    projectError: false,
  });

  // Use the filters as needed

  const { isLoading, isFetching, data, refetch } = useLoadData<ApiResponse<Project>>(
    projectsApiKeyStore.getProjectDetailsRefeatch(selectedFilters?.projectID, !!selectedFilters?.projectID)
  );

  const validateAddLot = () => {
    if (!selectedFilters?.customerID) {
      setEnableError((prevState: any) => ({
        ...prevState,
        customerError: true,
        officeError: true,
        projectError: true,
      }));
      return true;
    }
    if (!selectedFilters?.officeID) {
      setEnableError((prevState: any) => ({
        ...prevState,
        officeError: true,
        projectError: true,
      }));
      return true;
    }
    if (!selectedFilters?.projectID) {
      setEnableError((prevState: any) => ({
        ...prevState,
        projectError: true,
      }));
      return true;
    }
    return false;
  };
  useEffect(() => {
    validateAddLot();
  }, []);

  const selectConfig: SelectConfig[] = [
    {
      title: 'Customer',
      optionsLabelKey: 'customerName',
      optionsValueKey: 'customerID',
      type: 'autocomplete',
      error: `${enableError?.customerError ? 'Select customer' : ''}`,
      getQueryKeyConfig: () => customersApiKeyStore.getCustomers(),
    },
    {
      title: 'Office',
      optionsLabelKey: 'officeName',
      optionsValueKey: 'officeID',
      type: 'autocomplete',
      error: `${enableError?.officeError ? 'Select office' : ''}`,
      getQueryKeyConfig: (value?: SelectResult) => officeApiKeyStore.getCustomerOffices(value?.customerID),
    },
    {
      title: 'Project',
      optionsLabelKey: 'projectName',
      optionsValueKey: 'projectID',
      type: 'autocomplete',
      error: `${enableError?.projectError ? 'Select project' : ''}`,
      getQueryKeyConfig: (value?: SelectResult) => projectsApiKeyStore.getOfficeProjects(value?.officeID),
    },
  ];

  const removeValidation = (filter: SelectResult) => {
    if (filter?.customerID) setEnableError((ps: any) => ({ ...ps, customerError: false }));
    if (filter?.officeID) setEnableError((ps: any) => ({ ...ps, officeError: false }));
    if (filter?.projectID) setEnableError((ps: any) => ({ ...ps, projectError: false }));
  };

  const handleFilterSelected = (filter: SelectResult) => {
    removeValidation(filter);
    setSelectedFilters(filter);
  };

  return (
    <SiTrackPage title="Add Lot/Unit">
      <div>
        <div className="innerContent">
          <div className="mBm">
            <SelectChainItem config={selectConfig} value={selectedFilters} onSelect={handleFilterSelected} />
          </div>
        </div>
        {isLoading || (isFetching && <LoadingIndicator isLoading={isLoading || isFetching} />)}
        {(!data?.data || !selectedFilters?.projectID) && (
          <Grid container className="noDataPage buildingBlocks">
            <Grid item className="noDataPageContent">
              <Grid>
                <p style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <b>No data available right now.</b>{' '}
                </p>
                <p style={{ textAlign: 'center' }}>
                  Please select a <b>Customer, Office,</b> and <b>Project</b> from the above options to{' '}
                  <b>Add Lot/Unit</b>.
                </p>
              </Grid>
            </Grid>
          </Grid>
        )}
        {!!selectedFilters?.projectID && data?.data && <EditProjectBuildingTab project={data?.data} />}
      </div>
    </SiTrackPage>
  );
};

export default EditProjectBuilding;
